export default "__VITE_ASSET__17b978c3__"